import { DevRedemptionService } from "../dev/redemption-service";
import { DevSignupInfoService } from "../dev/signup-info-service";
import { DevUserInfoService } from "../dev/user-info-service";
import { DevUserManagementService } from "../dev/user-management-service";
import { LocalRedemptionService } from "../local/redemption-service";
import { LocalSignupInfoService } from "../local/signup-info-service";
import { LocalUserInfoService } from "../local/user-info-service";
import { LocalUserManagementService } from "../local/user-management-service";
import { MockRedemptionService } from "../mock/redemption-service";
import { MockSignupInfoService } from "../mock/signup-info-service";
import { MockUserInfoService } from "../mock/user-info-service";
import { MockUserManagementService } from "../mock/user-management-service";
import { ProdRedemptionService } from "../prod/redemption-service";
import { ProdSignupInfoService } from "../prod/signup-info-service";
import { ProdUserInfoService } from "../prod/user-info-service";
import { ProdUserManagementService } from "../prod/user-management-service";

const PortalModes = {
    dev:{
        name: 'dev',
        nav: '(DEV)',
    },
    local:{
        name: 'local',
        nav: '(LOCAL)',
    },
    mock:{
        name: 'mock',
        nav: '(MOCK)',
    },
    prod:{
        name: 'prod',
        nav: '',
    }
};


export const GetEnvironmentTag = ()=>{
    const devMode = (process.env.REACT_APP_DEV_MODE ?? '').toLowerCase();

    if(devMode === 'dev')
        return 'dev';
    if(devMode === 'local')
        return 'local';
    if(devMode === 'mock')
        return 'mock';
    if((process.env.NODE_ENV ?? '').toLowerCase() === 'production')
        return 'prod';

    return 'dev';
};

export const GetEnvironmentNavLabel = ()=>{
    const tag = GetEnvironmentTag();
    return PortalModes[tag].nav;
};

export const ServiceOf = (props)=>{
    const tag = GetEnvironmentTag();
    return props[tag];
};


export const CoreServiceSelector = {
    GetUserInfoService: (session)=>{
        if(!session)
            return null;

         return ServiceOf({
            mock: new MockUserInfoService(session),
            dev: new DevUserInfoService(session),
            local: new LocalUserInfoService(session),
            prod: new ProdUserInfoService(session)
        });
    },

    GetUserManagementService: (session)=>{
        if(!session)
            return null;

         return ServiceOf({
            mock: new MockUserManagementService(session),
            dev: new DevUserManagementService(session),
            local: new LocalUserManagementService(session),
            prod: new ProdUserManagementService(session)
        });
    },

    GetSignupInfoService: ()=>{
         return ServiceOf({
            mock: new MockSignupInfoService(),
            dev: new DevSignupInfoService(),
            local: new LocalSignupInfoService(),
            prod: new ProdSignupInfoService()
        });
    },


    GetRedemptionService : (session)=>{
        if(!session)
            return null;

         return ServiceOf({
            mock: new MockRedemptionService(session),
            dev: new DevRedemptionService(session),
            local: new LocalRedemptionService(session),
            prod: new ProdRedemptionService(session)
        });
    }
};
